import { FormControl, FormHelperText, InputLabel, Stack, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from '../../utils/dayjs';
import { useField, useFormikContext } from '../../lib/formik/Formik';
import { useState } from 'react';
import { styled, SxProps, Theme, useTheme } from '@mui/material/styles';
import CalendarIcon from '../../assets/icons/CalendarIcon';


export const BootstrapDatePicker = styled(DatePicker)(({ theme }) => ({
    '&.MuiTextField-root': {
        '& fieldset': {
            borderRadius: "10px",
            backgroundColor: `${theme.palette.common.white}0D`,
            border: `0.5px solid ${theme.palette.text.secondary}80`,
        },
        // '&:hover fieldset': {
        //     border: `2px solid ${theme.palette.primary[500]}`
        // },
        '.MuiInputBase-input': {
            ...theme.typography.body_500,
            letterSpacing: "0.32px",
            color: theme.palette.text.primary,
            padding: "15px"
        },
    },
}));

export const DayJsDatePicker = (
    {
        id,
        name,
        label,
        maxDate,
        minDate,
        disabled = false,
        styleObj = {},
        currentDate = dayjs(),
        customHandleChange,
        resetDate = false
    }: {
        id?: string;
        name: string;
        label: string;
        maxDate?: Date;
        minDate?: Date;
        disabled?: boolean;
        styleObj?: SxProps<Theme>;
        currentDate?: dayjs.Dayjs | string;
        customHandleChange?: (date: any) => void;
        resetDate?: boolean;
    }
): JSX.Element => {
    const theme = useTheme()
    // const currentDate = dayjs();
    const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
    const formikContext = useFormikContext();
    const [field, meta, { setValue }] = useField(name);
    const [error, setError] = useState(false);
    // const onChange = (date: any) => {
    //     date == 'Invalid Date' && setError(true);
    //     date != 'Invalid Date' && setError(false);
    //     setValue(date);
    // };

    const onChange = (date: any) => {
        if (resetDate) {
            const utcDate = date
                ? dayjs.utc(dayjs(date).format('YYYY-MM-DD'))
                : dayjs.utc(dayjs().format('YYYY-MM-DD'));
            setValue(utcDate);
            return;
        }

        const utcDate = date ? dayjs.utc(dayjs(date).format('YYYY-MM-DD')) : date;
        setValue(utcDate);
    };

    const errorText = error ? 'Invalid Date' : meta.error && meta.touched ? meta.error : '';

    return (
        <FormControl fullWidth sx={{ my: { xs: 1, sm: 1, md: 2 } }}>
            {/* <InputLabel
                shrink
                htmlFor={id}
                sx={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                    mb: 1.8
                }}>
                DOB
            </InputLabel> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <BootstrapDatePicker
                    label={label}
                    value={dayjs(field.value)}
                    name={name}
                    onChange={customHandleChange ? customHandleChange : onChange}
                    // sx={{
                    //     fontSize: 14,
                    //     fontWeight: 500,
                    //     p: -3
                    // }}
                    slots={{
                        openPickerIcon: () => <CalendarIcon fillColor={disabled ? theme.palette.grey[100] : theme.palette.primary[500]} />,
                    }}
                    format="DD/MM/YYYY"
                    views={['year', 'month', 'day']}
                    maxDate={maxDate ? dayjs(maxDate) : undefined}
                    minDate={minDate ? dayjs(minDate) : undefined}
                    disabled={disabled}
                    sx={{
                        '& .Mui-disabled': {
                            cursor: !disabled ? 'pointer' : 'not-allowed !important',
                            pointerEvents: 'all',
                        },
                        ...styleObj
                    }}
                />
            </LocalizationProvider>
            {errorText && (
                <FormHelperText error sx={{ marginLeft: 'unset' }}>
                    {errorText}
                </FormHelperText>
            )}
        </FormControl>
    )
}